/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Margin, Panel, Hr, Text, Table, Link, Button } from 'shared/components'

import { admin } from 'routes/route.map'
import { EventsFilters } from './components/filters'
import { BinaryBetModal } from './components/binaryBetModal'
import { createColumns } from './columns.description'

import * as styles from './styles'

const EventsComponent = ({
  appStore,
  loadEvents,
  onResolveBet,
  onInwinableBet,
  onSearch,
}) => (
  <Panel>
    <div css={styles.pageHeader}>
      <Text as="h1" size={18} bold>
        Events
      </Text>
      <Margin tb={3}>
        <Hr width="full" />
      </Margin>
      <div css={styles.pageToolbar} data-testid="page-toolbar">
        <div css={styles.filtersSlot}>
          <Margin bottom={2}>
            <EventsFilters debounce={250} onSearch={onSearch} />
          </Margin>
        </div>
        <div css={styles.actionsSlot} data-testid="page-toolbar-action">
          <div css={styles.controlsWrapper}>
            <Link to={admin.events.add()}>
              <Button plain>
                <FontAwesomeIcon size="1x" icon="plus-circle" />
                <Text size={11}>Add event</Text>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>

    <BinaryBetModal onResolveBet={onResolveBet} onInwinableBet={onInwinableBet}>
      {(onTrigger) => {
        const columns = useMemo(
          () =>
            createColumns({
              loggedEntity: appStore.auth.loggedEntity,
              onOpenBinaryBetModal: onTrigger,
            }),
          [onTrigger]
        )

        return (
          <div css={styles.tableSection}>
            <Table id="events-table" columns={columns} loadData={loadEvents} />
          </div>
        )
      }}
    </BinaryBetModal>
  </Panel>
)

EventsComponent.propTypes = {
  appStore: PropTypes.shape(),
  loadEvents: PropTypes.func.isRequired,
  onResolveBet: PropTypes.func.isRequired,
  onInwinableBet: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
}

export default EventsComponent
